import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSettingsAction } from '../../actions/settings.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updatePhone } from '../../slices/settings.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const PhonePage = () => {
  const dispatch = useAppDispatch();

  const { phone } = useAppSelector((store) => store.settings.list);

  const handleChange = (v: string) => {
    dispatch(updatePhone(v));
  };

  const handleSave = async () => {
    await dispatch(updateSettingsAction({ key: 'phone', value: phone }));
  };

  return (
    <ContainerTemplate>
      <Card title="Телефон" className={'border-2 border-yellow'}>
        <div>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={phone ?? ''}
            onChange={({ target }) => handleChange(target.value)}
          />
        </div>
        <Button label="Сохранить" icon="pi pi-check" className={'mt-2'} onClick={handleSave} />
      </Card>
    </ContainerTemplate>
  );
};
